import DateRange from "../../pages/Admin/DateRange.model";
import ApiResponse from "../models/ApiResponse";
import CountPerLabPerState from "../models/statistics/CountPerLabPerState";
import CountStateChangesPerLabResponse from "../models/statistics/CountStateChangesPerLabResponse";
import DataPoints from "../models/statistics/DataPoints";
import Api from "./Api";

class StatisticsApi {
  constructor(private api: Api) {}

  public fetchDataPoints(dateRange: DateRange<string> | null): ApiResponse<DataPoints> {
    const url = "/test-request/v2/statistics/data-points";
    const query = dateRange && new URLSearchParams(dateRange);
    return this.api.get(query ? `${url}?${query}` : url);
  }

  public fetchTestRequestStateChangeCountPerLab(dateRange?: {
    from: string;
    to: string;
  }): ApiResponse<CountStateChangesPerLabResponse[]> {
    const url = "/test-request/v2/statistics/test-request-state-change-count-per-lab";
    const query = dateRange && new URLSearchParams(dateRange);
    return this.api.get(query ? `${url}?${query}` : url);
  }

  public fetchTestRequestCountPerLabAndState(): ApiResponse<CountPerLabPerState[]> {
    return this.api.get("/test-request/v2/statistics/test-request-count-per-lab-per-state");
  }
}

export default StatisticsApi;
